var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateEventIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 183,
    viewBox: "0 0 240 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 114,
    rx: 93.5,
    ry: 20,
    fill: "#EDF7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 79H92.5C92.5 79 96 93 116.5 91.5C139.5 91.5 138 77.5 138 77.5H172.5C172 87.1667 171.3 107.2 172.5 110C173.7 112.8 170.333 115.167 168.5 116C139 115.5 78.2 114.8 71 116C63.8 117.2 60.6667 114.167 60 112.5V79Z",
    fill: "#C3DFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.896 79.5327L147.013 57.9667H84.9845L61.1018 79.5327L57.8125 75.8673L83.0965 53.0333H148.901L174.185 75.8673L170.896 79.5327Z",
    fill: "#93C4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.625 118.4H64.375C60.3077 118.4 57 115.081 57 111V75.2333H96.3333V77.6999C96.3333 83.821 101.295 88.7999 107.396 88.7999H124.604C130.705 88.7999 135.667 83.821 135.667 77.6999V75.2333H175V111C175 115.081 171.692 118.4 167.625 118.4ZM61.9167 80.1666V111C61.9167 112.36 63.0192 113.467 64.375 113.467H167.625C168.981 113.467 170.083 112.36 170.083 111V80.1666H140.395C139.209 87.8416 132.579 93.7333 124.604 93.7333H107.396C99.421 93.7333 92.7909 87.8416 91.6047 80.1666H61.9167Z",
    fill: "#93C4E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.866 33.2112L92.2615 19.6443L88.1133 22.293L96.7176 35.8599L100.866 33.2112Z",
    fill: "#93C4E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.118 22.2886L140.97 19.6404L132.367 33.2072L136.515 35.8555L145.118 22.2886Z",
    fill: "#93C4E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.46 17.2667H113.543V33.3001H118.46V17.2667Z",
    fill: "#93C4E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateEventIcon);
export default __webpack_public_path__ + "static/media/EmptyStateEventIcon.8848422c.svg";
export { ForwardRef as ReactComponent };